import React, { useEffect, useRef, useState } from "react";
import cn from "classnames";
import styles from "./Login.module.sass";
import TextInput from "../../../components/TextInput";
import { useUser } from "../../../context";
import { GetMe, UpdateMe } from "../../../Services/lib/user";
import Loader from "../../../components/Loader";
import { UseApi } from "../../../hooks/use-api";
import { Step2 } from "../../ResetPassword";
import Modal from "../../../components/Modal";
import { UseDisclosure } from "../../../hooks/use-disclosure";
import Card from "../../../components/Card";
import Icon from "../../../components/Icon";
import { ToastEmitter } from "../../../Services/assets/toast-emitter";
import settings from "../../../i11/Settings";
const Login = () => {
	const {
		locale,
		tokens: { username, group, id },
	} = useUser();
	const { isOpen, onOpen, onClose } = UseDisclosure();

	const [{ isLoading, data }, fetch] = UseApi({
		service: GetMe,
	});

	const [{ isLoading: phoneLoading }, setPhone_] = UseApi({
		service: UpdateMe,
	});

	const [isEdit, setEdit] = useState(false);
	const ref = useRef();

	const [phone, setPhone] = useState("");

	useEffect(() => {
		fetch(id);
	}, []);

	const savePhone = async () => {
		const res = await setPhone_({
			_id: id,
			mobileNumber: phone,
		});
		if (res) {
			setEdit(false);
			ToastEmitter({
				msg: "Your phone number successfully updated",
				type: "success",
			});
		}
	};

	useEffect(() => {
		if (data) setPhone(data.mobileNumber);
	}, [data]);

	useEffect(() => {
		if (isEdit) {
			ref.current.focus();
		}
	}, [isEdit]);

	return (
		<>
			<Card
				className={cn(styles.card)}
				title={settings[locale].user_info}
				classTitle="title-purple"
			>
				{isLoading ? (
					<div className={styles.loaderWrap}>
						<Loader className={styles.Loader} />
					</div>
				) : (
					<div className={styles.fieldset}>
						<TextInput
							className={styles.field}
							label={settings[locale].username}
							type="text"
							required
							value={username}
							disabled
						/>
						<TextInput
							className={styles.field}
							label={settings[locale].role}
							type="text"
							required
							value={group}
							disabled
						/>
						<TextInput
							className={styles.field}
							label={settings[locale].email_address}
							type="text"
							value={data?.email}
							required
							disabled
						/>
						<div className={cn(styles.field, styles.editable)}>
							<TextInput
								ref={ref}
								className={styles.editableInput}
								label={settings[locale].phone_number}
								name="confirm-password"
								type="text"
								value={phone}
								required
								onChangeInput={setPhone}
								disabled={!isEdit}
							/>
							<button
								type="button"
								onClick={() => {
									if (isEdit) {
										savePhone();
									} else {
										setEdit(true);
									}
								}}
								className={cn("button", {
									[styles.button__]: !isEdit,
									disabled: phoneLoading,
								})}
							>
								{isEdit ? (
									<div>
										{phoneLoading ? <Loader /> : settings[locale].confirm}
									</div>
								) : (
									<Icon name="edit" size="20" />
								)}
							</button>
						</div>
						<button onClick={onOpen} className={cn("button", styles.button)}>
							{settings[locale].change_password}
						</button>
					</div>
				)}
			</Card>
			<Modal visible={isOpen} onClose={onClose}>
				{isOpen && (
					<div className={styles.passcontainer}>
						<Step2 username={username} modular onClose={onClose} />
					</div>
				)}
			</Modal>
		</>
	);
};

export default Login;
